import * as React from "react";
const SvgFiRrSpy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="m17.422 14.82 1.477-1.73c.518-.678.339-1.661-.399-2.09-.235-.137-.594-.408-.973-.665A6 6 0 0 0 18 8h1a1 1 0 1 0 0-2h-1c0-1.406-1.491-6-3.5-6-.795 0-1.614.369-2.5 1.128C11.113.369 10.295 0 9.5 0 7.491 0 6 4.594 6 6H5a1 1 0 1 0 0 2h1c0 .828.169 1.617.473 2.335-.379.257-.738.528-.973.665-.737.429-.917 1.412-.399 2.09l1.485 1.74A8.92 8.92 0 0 0 2.999 22v1a1 1 0 1 0 2 0v-1a6.94 6.94 0 0 1 2.884-5.65L10.999 20v3a1 1 0 1 0 2 0v-3l3.119-3.654A7 7 0 0 1 18.999 22v1a1 1 0 1 0 2 0v-1a9.01 9.01 0 0 0-3.578-7.18zM10.5 16l-.823-2.468A6 6 0 0 0 12 14a6 6 0 0 0 2.323-.468L13.5 16zM9.62 2.012c.212.04.582.195 1.156.702a1.854 1.854 0 0 0 2.448 0c.573-.506.943-.661 1.155-.701.562.483 1.62 2.906 1.62 3.988h-8c0-1.082 1.058-3.505 1.62-3.988zM16 8c0 2.206-1.794 4-4 4s-4-1.794-4-4z"
    />
  </svg>
);
export default SvgFiRrSpy;
